import React, { useEffect, useState } from "react";
import {
  LineChart as ReLineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const LineChart = ({ data }) => {
  const [chartData, setChartData] = useState([]);

  const unitPreference = localStorage.getItem("unit") || "Metric";
  const tempLabel = unitPreference === "Imperial" ? "Temp (°F)" : "Temp (°C)";

  useEffect(() => {
    // ✅ Validate incoming data
    if (
      isNaN(data.temperature) ||
      isNaN(data.humidity) ||
      data.temperature === null ||
      data.humidity === null
    ) {
      return; // ✅ Do not update chart if data is invalid
    }

    setChartData((prev) => {
      const newData = [
        ...prev,
        {
          time: new Date().toLocaleTimeString(),
          temperature: parseFloat(data.temperature),
          humidity: parseFloat(data.humidity),
        },
      ];
      return newData.slice(-10);
    });
  }, [data]);

  return (
    <div className="bg-gray-800 p-4 rounded-xl shadow-md">
      <h3 className="text-lg font-bold mb-4">
        Temperature & Humidity (Last 10 updates)
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <ReLineChart data={chartData}>
          <XAxis dataKey="time" stroke="#ccc" />
          <YAxis stroke="#ccc" />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="temperature"
            stroke="#f87171"
            name={tempLabel}
          />
          <Line
            type="monotone"
            dataKey="humidity"
            stroke="#60a5fa"
            name="Humidity (%)"
          />
        </ReLineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChart;
